import type { AutoFormInputComponentProps } from "../types"
import { Checkbox } from "@/components/ui/checkbox"
import { FormControl, FormItem } from "@/components/ui/form"
import { cn } from "@/lib/utils"
import AutoFormLabel from "../common/label"
import AutoFormTooltip from "../common/tooltip"

export default function AutoFormCheckbox({
  label,
  isRequired,
  field,
  fieldConfigItem,
  fieldProps,
}: AutoFormInputComponentProps) {
  return (
    <div className={cn(fieldConfigItem?.containerClassName)}>
      <FormItem>
        <div className="mb-3 flex items-center gap-3">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
              {...fieldProps as Record<string, unknown>}
            />
          </FormControl>
          <AutoFormLabel
            isRequired={isRequired}
            label={fieldConfigItem?.label ?? label}
          />
        </div>
      </FormItem>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
    </div>
  )
}
